// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemsHeader":"itemsHeader_NGog8"};